// Module
var code = "<div ng-form=\"valMsgForm\"> <div fg-property-field=\"message\" fg-property-field-label=\"Message\"> <input type=\"text\" name=\"message\" title=\"{{ tooltip }}\" placeholder=\"Optional message\" ng-model=\"field.validation.messages[validationType]\" class=\"form-control\" flowingly-xss-validation/> </div> </div> ";
// Exports
export default code;